import cx from 'classnames'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import { StrongNode, nodes } from 'prose-core'

import { ReactComponent as ArrowRight } from 'assets/icons/arrowRight24.svg'
import { ReactComponent as JiraLogo } from 'assets/icons/logos/jira.svg'
import { JiraIssue } from './types'

import Styles from './JiraIssueCard.module.scss'
import { AnchorOrDiv, Skel } from '../EmbedCommon/common'

dayjs.extend(relativeTime)

export const JiraIssueCard = ({
  node,
  data,
  isLoading,
  preview,
}: {
  node: StrongNode<typeof nodes.jira_embed>
  data: JiraIssue
  isLoading: boolean
  preview?: true
}) => {
  if (isLoading) {
    return (
      <div className={cx(Styles.wrapper, Styles.isLoading)}>
        <div className={Styles.icon}>
          <JiraLogo width={32} height={32} />
        </div>

        <div className={Styles.body}>
          <Skel />
          <Skel width={'65%'} />
        </div>
      </div>
    )
  }

  return (
    <div className={cx(Styles.wrapper, Styles[node.attrs.mode])}>
      <img className={Styles.icon} src={data.fields.issuetype.iconUrl} alt={data.fields.issuetype.name} />

      <AnchorOrDiv link={preview ? undefined : node?.attrs.link} className={Styles.summary}>
        {data.fields.summary}

        <div className={cx(Styles.label, Styles[data.fields.status.statusCategory.key])}>{data.fields.status.name}</div>
      </AnchorOrDiv>

      <div className={Styles.status}>
        <>
          {data.key} by {data.fields.reporter.displayName}, updated{' '}
          <span title={dayjs(data.fields.updated).format()}>{dayjs(data.fields.updated).fromNow()}</span>
        </>
      </div>

      <AnchorOrDiv link={preview ? undefined : node?.attrs.link} className={Styles.button}>
        <ArrowRight />
      </AnchorOrDiv>
    </div>
  )
}
